<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    width="600px"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="租车点编号" prop="code">
        <el-input v-model="form.code" placeholder="请输入租车点编号" v-trim/>
      </el-form-item>
      <el-form-item label="租车点名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入租车点名称" v-trim/>
      </el-form-item>
      <el-form-item label="经纬度" prop="longAndLat">
        <el-input v-model="form.longAndLat" placeholder="请输入经纬度，英文逗号隔开" @change="changeLongAndLat" v-trim/>
        <div>
          <a href="https://lbs.qq.com/getPoint/" target="_blank" rel="noopener noreferrer">腾讯地图经纬度摄取经纬度</a>
        </div>
      </el-form-item>
      <!-- <el-form-item label="纬度" prop="latitude">
        <el-input v-model="form.latitude" placeholder="请输入纬度" v-trim/>
      </el-form-item> -->
      <el-form-item label="详细地址" prop="addr">
        <el-input v-model="form.addr" placeholder="请输入详细地址" v-trim/>
      </el-form-item>

      <!-- <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      
      
      
      <el-form-item label="状态 0启用 1禁用" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态 0启用 1禁用" v-trim/>
      </el-form-item>
      
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item> -->
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaRentSiteWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    const longAndLatVal = (rule, value, callback) => {
      let longAndLat = value.split(',')
      this.form.latitude = longAndLat[0]
      this.form.longitude = longAndLat.length==2 ? longAndLat[1] : ''
      if (!this.form.longitude || !this.form.latitude) {
        callback(new Error())
      } else {
        callback()
      }
    }
    return {
      // 表单数据
      form: {
        id: null,
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        name: '',
        code: '',
        longAndLat: '',
        longitude: '',
        latitude: '',
        status: '',
        addr: '',
        info: ''
      },
      // 验证规则
      rules: {
        code: [
          { required: true, message: '请输入租车点编号', tigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入租车点名称', tigger: 'blur' },
        ],
        longAndLat: [
          { required: true, validator: longAndLatVal, message: '请输入经纬度，英文逗号隔开', tigger: 'change' },
        ],
      }
    }
  },
  created () {
    this.config({
      api: '/business/rentSite',
      'field.id': 'id'
    })
  },
  methods: {
    open (title, target) {
      this.title = title
      this.visible = true
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.form.longAndLat = `${this.form.latitude},${this.form.longitude}`
      })
    },
    changeLongAndLat(v) {
      let longAndLat = v.split(',')
      // console.log(longAndLat);
      this.form.latitude = longAndLat[0]
      this.form.longitude = longAndLat.length==2 ? longAndLat[1] : ''
    }
  },
}
</script>
